export const GET_ALL_REQUEST = "GET_ALL_REQUEST";
export const SET_ALL_REQUEST = "SET_ALL_REQUEST";
